module.exports = __webpack_public_path__ + "img/pin.9e475a4e.svg";